import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Moon, Star, ArrowDown, Check, X, ArrowRight, ShieldCheck, Plus, Minus, Gift, BookOpen, Baby, Heart, Clock, CheckCircle2 } from 'lucide-react';
export function App() {
  return <div className="font-dmsans text-gray-800 bg-cream min-h-screen scroll-smooth" data-id="element-0">
      <HeroSection data-id="element-1" />
      <WhoIsItForSection data-id="element-2" />
      <BridgeSection data-id="element-3" />
      <CreatorSection data-id="element-4" />
      <BeforeAfterSection data-id="element-5" />
      <WhatYouReceiveSection data-id="element-6" />
      <BonusesSection data-id="element-7" />
      <TestimonialsSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <OffersSection data-id="element-10" />
      <ValueSummarySection data-id="element-11" />
      <GuaranteeSection data-id="element-12" />
      <FinalCTASection data-id="element-13" />
    </div>;
}
function HeroSection() {
  return <section className="bg-salvia-dark text-white py-20 px-6 relative overflow-hidden flex flex-col items-center text-center" data-id="element-14">
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-15">
        {/* Decorative organic branches could go here as SVG background */}
      </div>

      <div className="max-w-4xl mx-auto z-10 flex flex-col items-center" data-id="element-16">
        <Moon className="w-16 h-16 text-rose mb-6" data-id="element-17" />

        <h1 className="font-playfair text-4xl md:text-5xl lg:text-[52px] leading-tight mb-8" data-id="element-18">
          El método para que tu bebé duerma toda la noche, sin dejarlo llorar.
        </h1>

        <p className="text-rose text-lg md:text-[20px] max-w-2xl mx-auto mb-6" data-id="element-19">
          Creado con amor para que tu maternidad sea más liviana y dejes de
          levantarte en cada madrugada.
        </p>

        <div className="mb-8" data-id="element-20">
          <span className="font-playfair text-2xl font-bold tracking-wider text-rose" data-id="element-21">
            Mamá sin Caos
          </span>
        </div>

        <a href="#ofertas" className="inline-block bg-rose hover:bg-rose-600 text-white font-bold py-4 px-10 rounded-xl transition-colors duration-300 text-lg shadow-lg mb-12" data-id="element-22">
          ✨ QUIERO QUE MI BEBÉ DUERMA ✨
        </a>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="w-full max-w-4xl mx-auto" data-id="element-23">
          <img src="https://cdn.magicpatterns.com/uploads/mKhs5wjS8BXpHQnivgjMRR/Para_la_pagina_de_venta.png" alt="El Manual del sueño infantil — Mamá sin Caos, con 3 bonos exclusivos" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-24" />
        </motion.div>
      </div>
    </section>;
}
function TestimonialsSection() {
  const testimonials = [{
    text: 'Mi bebé de 5 meses empezó a dormir 5 horas seguidas en la primera semana. Lloré de alivio cuando me di cuenta de que era posible.',
    name: 'Valentina M.',
    detail: 'Mamá de Luca (5 meses) Buenos Aires',
    avatar: 'https://i.pravatar.cc/150?img=1'
  }, {
    text: 'Tenía miedo de que fuera otro método de dejar llorar. No tiene nada que ver. Es suave, tiene sentido y funciona. Mi hija pasó de despertarse 6 veces a dormir casi toda la noche.',
    name: 'Camila R.',
    detail: 'Mamá de Sofía (7 meses) Córdoba',
    avatar: 'https://i.pravatar.cc/150?img=5'
  }, {
    text: 'Lo leí de madrugada mientras la amamantaba. Al tercer día ya noté la diferencia en las siestas. Al séptimo día dormí 6 horas seguidas por primera vez en meses.',
    name: 'Florencia T.',
    detail: 'Mamá de Mateo (4 meses) Rosario',
    avatar: 'https://i.pravatar.cc/150?img=9'
  }, {
    text: "No lo podía creer. Pensaba que mi bebé era 'de los que no duermen'. Resulta que era yo la que no sabía cómo enseñarle. Ahora sí sé.",
    name: 'Luciana P.',
    detail: 'Mamá de Emma (9 meses) Mendoza',
    avatar: 'https://i.pravatar.cc/150?img=10'
  }];
  return <section className="bg-cream py-20 px-6" data-id="element-25">
      <div className="max-w-6xl mx-auto" data-id="element-26">
        <h2 className="font-playfair text-3xl md:text-4xl text-salvia-dark text-center mb-12 max-w-3xl mx-auto" data-id="element-27">
          Mirá lo que cambió en la vida de más de 1.000 mamás después de aplicar
          el Manual de Sueño Infantil:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-28">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-29">
              <div className="flex text-gold mb-4" data-id="element-30">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-current" data-id="element-31" />)}
              </div>
              <p className="text-gray-700 italic mb-6 flex-grow text-lg" data-id="element-32">
                "{t.text}"
              </p>
              <div className="flex items-center mt-auto" data-id="element-33">
                <img src={t.avatar} alt={t.name} className="w-12 h-12 rounded-full mr-4 object-cover" data-id="element-34" />
                <div data-id="element-35">
                  <p className="font-bold text-salvia" data-id="element-36">{t.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-37">{t.detail}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
function BridgeSection() {
  return <section className="bg-rose-verysoft py-16 px-6 flex flex-col items-center text-center relative" data-id="element-38">
      <div className="w-24 h-px bg-rose mb-8" data-id="element-39"></div>
      <h2 className="font-playfair italic text-2xl md:text-3xl text-salvia-dark max-w-3xl mx-auto leading-relaxed" data-id="element-40">
        Seguí leyendo y entendé por qué el Manual de Sueño Infantil es el más
        completo y gentil del mercado.
      </h2>
      <div className="w-24 h-px bg-rose mt-8 mb-8" data-id="element-41"></div>

      <motion.div animate={{
      y: [0, 10, 0]
    }} transition={{
      repeat: Infinity,
      duration: 2
    }} data-id="element-42">
        <ArrowDown className="w-8 h-8 text-salvia" data-id="element-43" />
      </motion.div>
    </section>;
}
function CreatorSection() {
  return <section className="bg-cream py-20 px-6" data-id="element-44">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-12" data-id="element-45">
        <div className="md:w-1/3 flex flex-col items-center" data-id="element-46">
          <div className="w-48 h-48 rounded-full p-2 border-4 border-rose mb-6" data-id="element-47">
            <img src="https://cdn.magicpatterns.com/uploads/aSrEGBYEhjYBegAu5hQKA6/ChatGPT_Image_30_jun_2026,_11_18_39_p.m..png" alt="Luciana Vazcoba" className="w-full h-full rounded-full object-cover object-[75%_20%]" data-id="element-48" />
          </div>
          <div className="text-center" data-id="element-49">
            <p className="font-playfair text-2xl text-salvia font-bold mb-2" data-id="element-50">
              Luciana Vazcoba
            </p>
            <p className="text-sm text-gray-600 mb-1" data-id="element-51">📱 @mamasiincaos</p>
            <p className="text-sm text-gray-600" data-id="element-52">🌐 mamasincaos.store</p>
          </div>
        </div>

        <div className="md:w-2/3 space-y-6 text-lg text-gray-700" data-id="element-53">
          <p data-id="element-54">
            <span className="text-salvia font-bold" data-id="element-55">
              🌿 Mi nombre es Luciana Vazcoba.
            </span>{' '}
            Soy periodista y, por eso, durante mi proceso de maternidad como
            primeriza me dediqué a investigar y a escribir todo lo que me sirvió
            para que el sueño infantil de mi bebé no fuese un problema. Así
            nació: El Manual del sueño infantil.
          </p>
          <p data-id="element-56">
            A través del método que desarrollé, soy responsable de transformar
            la vida de más de 1.000 familias argentinas que aplican mi
            metodología y logran que sus bebés duerman hasta 10 horas seguidas.
          </p>
          <p data-id="element-57">
            El método que diseñé en este Manual te permite enseñarle a tu bebé
            con amor y respeto, para que no sufra ningún tipo de trauma en el
            proceso. Porque creemos que un bebé puede aprender a dormir sin
            necesidad de ser abandonado a su llanto.
          </p>
          <div className="bg-white p-6 rounded-xl border-l-4 border-rose mt-8 italic text-salvia-dark font-playfair text-xl" data-id="element-58">
            "Mamá sin Caos nació de una madrugada de agotamiento. Y hoy ayuda a
            miles de familias a recuperar el descanso que merecen."
          </div>
        </div>
      </div>
    </section>;
}
function WhatYouReceiveSection() {
  const items = ['Fundamentos básicos del sueño infantil que ningún médico te explicó en la guardia', 'Cómo manejar las siestas sin resistencia ni llanto excesivo', 'Sueño nocturno: cómo construirlo paso a paso desde cero', 'Tablas completas de ventanas de sueño por edad (0 a 12 meses)', 'El Protocolo de Transferencia Invisible: cómo pasar al bebé de los brazos a la cuna sin que se despierte', 'Horarios para dormir y despertar adaptados a la realidad argentina', 'Cómo manejar las regresiones y los saltos de desarrollo sin perder lo construido', 'Cómo eliminar las asociaciones de sueño (teta, brazos, hamaca) de forma gradual y respetuosa', 'Qué hacer con los despertares nocturnos según la edad y la causa', 'Ambiente ideal para el sueño: temperatura, oscuridad y ruido blanco explicados con datos', 'Y mucho más...'];
  return <section className="bg-offwhite py-20 px-6 relative" data-id="element-59">
      <div className="max-w-4xl mx-auto" data-id="element-60">
        <div className="flex items-center justify-between mb-12" data-id="element-61">
          <h2 className="font-playfair text-3xl md:text-4xl text-rose font-bold flex items-center" data-id="element-62">
            <BookOpen className="mr-4 w-8 h-8" data-id="element-63" />
            LO QUE RECIBÍS EN EL MANUAL DE SUEÑO INFANTIL
          </h2>
          <Moon className="w-12 h-12 text-salvia opacity-20 hidden md:block" data-id="element-64" />
        </div>

        <p className="text-xl text-gray-700 mb-10" data-id="element-65">
          El Manual consiste en un eBook completo con información valiosa para
          atender desde recién nacidos hasta bebés de 12 meses.
        </p>

        <div className="space-y-4" data-id="element-66">
          <p className="font-bold text-salvia-dark text-xl mb-6" data-id="element-67">
            Vas a aprender:
          </p>
          {items.map((item, i) => <div key={i} className="bg-white p-5 rounded-lg shadow-sm border-l-[3px] border-rose flex items-start" data-id="element-68">
              <Check className="w-6 h-6 text-salvia mr-4 flex-shrink-0 mt-0.5" data-id="element-69" />
              <p className="text-gray-700 text-lg" data-id="element-70">{item}</p>
            </div>)}
        </div>
      </div>
    </section>;
}
function BeforeAfterSection() {
  const before = ['Te levantás de madrugada múltiples veces por los despertares nocturnos', 'Tu bebé solo duerme si está en brazos o tomando la teta', 'Te sentís agotada porque no podés dormir seguido', 'La maternidad se vuelve pesada y la familia vive cansada y estresada', 'Las siestas son cortas y con mucha resistencia cada vez', 'Sentís que probaste todo y nada funciona'];
  const after = ['Tu bebé va a aprender a dormir con autonomía y sin tu presencia', 'Las siestas van a ser buenas, largas y sin resistencia', 'Vas a dormir toda la noche porque tu bebé no va a despertarse en la madrugada', 'Tu familia va a ser más unida, más tranquila y más feliz', 'La maternidad se vuelve liviana y recuperás tiempo para cuidarte a vos misma', 'Vas a disfrutar a tu bebé en lugar de solo sobrevivir el día a día'];
  return <section className="bg-cream py-20 px-6" data-id="element-71">
      <div className="max-w-6xl mx-auto" data-id="element-72">
        <div className="flex flex-col lg:flex-row gap-8 items-stretch" data-id="element-73">
          {/* Before */}
          <div className="flex-1 bg-red-50 rounded-2xl p-8 border border-red-100" data-id="element-74">
            <h3 className="font-playfair text-2xl text-gray-800 font-bold mb-8 flex items-center" data-id="element-75">
              <span className="text-2xl mr-3" data-id="element-76">⚡</span> LO QUE PASA SI NO
              APLICÁS EL MANUAL:
            </h3>
            <div className="space-y-6" data-id="element-77">
              {before.map((item, i) => <div key={i} className="flex items-start" data-id="element-78">
                  <X className="w-6 h-6 text-red-400 mr-4 flex-shrink-0 mt-0.5" data-id="element-79" />
                  <p className="text-gray-700" data-id="element-80">{item}</p>
                </div>)}
            </div>
          </div>

          {/* Arrow */}
          <div className="hidden lg:flex items-center justify-center" data-id="element-81">
            <div className="bg-white p-4 rounded-full shadow-md" data-id="element-82">
              <ArrowRight className="w-8 h-8 text-salvia" data-id="element-83" />
            </div>
          </div>

          {/* After */}
          <div className="flex-1 bg-salvia-soft rounded-2xl p-8 border border-salvia-light" data-id="element-84">
            <h3 className="font-playfair text-2xl text-salvia font-bold mb-8 flex items-center" data-id="element-85">
              <Moon className="w-6 h-6 mr-3 text-salvia" data-id="element-86" /> LO QUE VA A PASAR
              DESPUÉS DE APLICAR EL MANUAL:
            </h3>
            <div className="space-y-6" data-id="element-87">
              {after.map((item, i) => <div key={i} className="flex items-start" data-id="element-88">
                  <CheckCircle2 className="w-6 h-6 text-salvia mr-4 flex-shrink-0 mt-0.5" data-id="element-89" />
                  <p className="text-gray-800 font-medium" data-id="element-90">{item}</p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function WhoIsItForSection() {
  const avatars = [{
    icon: <Baby className="w-12 h-12 text-rose-DEFAULT" data-id="element-91" />,
    title: 'MAMÁS EMBARAZADAS',
    desc: 'Que quieren aprender con anticipación todo sobre el sueño infantil antes de que nazca el bebé, evitando el estrés y el cansancio de los primeros meses.',
    bg: 'bg-rose-soft'
  }, {
    icon: <Clock className="w-12 h-12 text-salvia-dark" data-id="element-92" />,
    title: 'MAMÁS DE BEBÉS DE 0 A 6 MESES',
    desc: 'Que quieren establecer buenos hábitos de sueño desde los primeros meses de vida. Al aplicar las técnicas del manual, tu bebé va a crecer durmiendo en el momento justo.',
    bg: 'bg-cream'
  }, {
    icon: <Moon className="w-12 h-12 text-salvia" data-id="element-93" />,
    title: 'MAMÁS DE BEBÉS DE 6 A 12 MESES',
    desc: 'Si tu bebé ya tiene más de 6 meses y todavía no duerme solo, el manual te va a mostrar exactamente qué hacer para terminar con los despertares nocturnos de una vez por todas.',
    bg: 'bg-salvia-light'
  }, {
    icon: <Heart className="w-12 h-12 text-gold" data-id="element-94" />,
    title: 'PAPÁS Y FAMILIAS QUE QUIEREN ACOMPAÑAR CON AMOR',
    desc: 'En este método no vas a encontrar abandono ni llanto sin respuesta. Al contrario: vas a enseñar autonomía con amor, respeto y presencia constante.',
    bg: 'bg-gold-soft'
  }];
  return <section className="bg-white py-20 px-6" data-id="element-95">
      <div className="max-w-6xl mx-auto" data-id="element-96">
        <h2 className="font-playfair text-3xl md:text-4xl text-salvia font-bold text-center mb-16" data-id="element-97">
          ¿PARA QUIÉN ES ESTE MANUAL?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-98">
          {avatars.map((avatar, i) => <div key={i} className={`${avatar.bg} p-8 rounded-2xl flex flex-col items-center text-center shadow-sm`} data-id="element-99">
              <div className="bg-white p-4 rounded-full shadow-sm mb-6" data-id="element-100">
                {avatar.icon}
              </div>
              <h3 className="font-bold text-xl text-gray-800 mb-4" data-id="element-101">
                {avatar.title}
              </h3>
              <p className="text-gray-700" data-id="element-102">{avatar.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}
function BonusesSection() {
  const bonuses = [{
    num: 1,
    title: 'AUDIO-GUÍA SOS 3 AM',
    desc: 'Tu salvavidas para el momento exacto en que nada funciona y el agotamiento te gana.',
    items: ['3 Audios MP3 (2 min c/u)', 'Flujograma de Crisis en PDF', 'Protocolo de 5 pasos para usar en la oscuridad', 'Termómetro Emocional para saber cuándo podés seguir y cuándo pedir ayuda'],
    value: '4.500'
  }, {
    num: 2,
    title: 'GUÍA ALIMENTACIÓN Y SUEÑO',
    desc: 'Aprendé a distinguir si tu bebé se despierta por hambre real o por hábito, y cómo asegurar que llegue a la noche con el tanque lleno.',
    items: ['Tabla Hambre vs. Hábito', 'Protocolo de Tomas de Carga', 'El ciclo Come-Juega-Duerme', 'Los 5 mitos de alimentación y sueño que podés descartar para siempre'],
    value: '6.000'
  }, {
    num: 3,
    title: 'PACK DE PLANTILLAS "RUTINAS SIN CAOS"',
    desc: 'Horarios prediseñados por edad para no tener que calcular nada. Imprimí y usá desde hoy.',
    items: ['4 Rutinas completas (0 a 3 · 3 a 6 · 6 a 9 · 9 a 12 meses)', 'Tracker diario de 7 días', 'Versión para heladera (para papá · abuela · niñera)', 'Tabla de transición de siestas'],
    value: '3.500'
  }];
  return <section className="bg-cream py-20 px-6" data-id="element-103">
      <div className="max-w-5xl mx-auto" data-id="element-104">
        <h2 className="font-playfair text-3xl md:text-4xl text-salvia-dark font-bold text-center mb-16 flex items-center justify-center" data-id="element-105">
          <Gift className="w-10 h-10 mr-4 text-rose" data-id="element-106" />
          AL COMPRAR EL MANUAL RECIBÍS 3 BONOS EXCLUSIVOS DE REGALO
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-107">
          {bonuses.map((bono, i) => <div key={i} className="bg-white rounded-2xl overflow-hidden shadow-md border border-gray-100 flex flex-col" data-id="element-108">
              <div className="bg-gold text-white p-6 text-center relative" data-id="element-109">
                <Gift className="w-12 h-12 mx-auto mb-2 opacity-80" data-id="element-110" />
                <h3 className="font-playfair font-bold text-xl" data-id="element-111">
                  BONO {bono.num}
                </h3>
                <p className="font-bold text-lg" data-id="element-112">{bono.title}</p>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-113">
                <p className="text-gray-600 mb-6 text-sm" data-id="element-114">{bono.desc}</p>
                <ul className="space-y-3 mb-8 flex-grow" data-id="element-115">
                  {bono.items.map((item, j) => <li key={j} className="flex items-start text-sm text-gray-700" data-id="element-116">
                      <Check className="w-4 h-4 text-salvia mr-2 flex-shrink-0 mt-0.5" data-id="element-117" />
                      <span data-id="element-118">{item}</span>
                    </li>)}
                </ul>
                <div className="mt-auto pt-4 border-t border-gray-100 text-center" data-id="element-119">
                  <p className="text-gray-400 text-sm line-through mb-1" data-id="element-120">
                    Valor real: ${bono.value} ARS
                  </p>
                  <p className="text-salvia font-bold text-lg flex items-center justify-center" data-id="element-121">
                    Con tu compra: GRATIS ✨
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
function OffersSection() {
  return <section className="bg-cream py-20 px-6" id="ofertas" data-id="element-122">
      <div className="max-w-5xl mx-auto" data-id="element-123">
        <h2 className="font-playfair text-3xl md:text-4xl text-salvia-dark font-bold text-center mb-16" data-id="element-124">
          💎 ELEGÍ TU PACK
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-125">
          {/* Oferta 1 */}
          <div className="bg-white rounded-2xl p-8 border-2 border-rose flex flex-col shadow-sm" data-id="element-126">
            <div className="mb-6" data-id="element-127">
              <h3 className="font-playfair text-2xl font-bold text-gray-800 mb-2" data-id="element-128">
                📖 OFERTA 1
              </h3>
              <p className="text-rose font-bold text-lg" data-id="element-129">
                PACK: EL MANUAL DEL SUEÑO INFANTIL
              </p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-130">
              <li className="flex items-start" data-id="element-131">
                <Check className="w-5 h-5 text-salvia mr-3 flex-shrink-0" data-id="element-132" />{' '}
                <span className="text-gray-700" data-id="element-133">
                  Manual completo (0-12 meses)
                </span>
              </li>
              <li className="flex items-start" data-id="element-134">
                <Check className="w-5 h-5 text-salvia mr-3 flex-shrink-0" data-id="element-135" />{' '}
                <span className="text-gray-700" data-id="element-136">
                  Bono 1: Audio-Guía SOS 3 AM
                </span>
              </li>
              <li className="flex items-start" data-id="element-137">
                <Check className="w-5 h-5 text-salvia mr-3 flex-shrink-0" data-id="element-138" />{' '}
                <span className="text-gray-700" data-id="element-139">
                  Bono 2: Alimentación y Sueño
                </span>
              </li>
              <li className="flex items-start" data-id="element-140">
                <Check className="w-5 h-5 text-salvia mr-3 flex-shrink-0" data-id="element-141" />{' '}
                <span className="text-gray-700" data-id="element-142">
                  Bono 3: Pack Plantillas Rutinas
                </span>
              </li>
            </ul>

            <div className="text-center mt-auto" data-id="element-143">
              <p className="text-gray-400 line-through mb-2" data-id="element-144">
                Valor total: $39.000 ARS
              </p>
              <p className="text-sm font-bold text-gray-600 mb-1" data-id="element-145">HOY SOLO:</p>
              <p className="text-4xl font-bold text-salvia mb-6" data-id="element-146">$15.000 ARS</p>
              <a href="https://www.mamasincaos.store/cart/45253862490135:1" className="block w-full bg-salvia hover:bg-salvia-dark text-white font-bold py-4 px-6 rounded-xl transition-colors duration-300 text-center" data-id="element-147">
                QUIERO ESTE PACK
              </a>
            </div>
          </div>

          {/* Oferta 2 */}
          <div className="bg-white rounded-2xl p-8 border-4 border-gold flex flex-col shadow-xl relative transform md:-translate-y-4" data-id="element-148">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gold text-white px-6 py-1 rounded-full font-bold text-sm shadow-md whitespace-nowrap" data-id="element-149">
              ⭐ MÁS ELEGIDO ⭐
            </div>

            <div className="mb-6 mt-2" data-id="element-150">
              <h3 className="font-playfair text-2xl font-bold text-gray-800 mb-2" data-id="element-151">
                📖📔 OFERTA 2
              </h3>
              <p className="text-gold font-bold text-lg" data-id="element-152">
                PACK COMPLETO + BITÁCORA DE 21 DÍAS
              </p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-153">
              <li className="flex items-start" data-id="element-154">
                <Check className="w-5 h-5 text-salvia mr-3 flex-shrink-0" data-id="element-155" />{' '}
                <span className="text-gray-700" data-id="element-156">
                  Manual completo (0-12 meses)
                </span>
              </li>
              <li className="flex items-start" data-id="element-157">
                <Check className="w-5 h-5 text-salvia mr-3 flex-shrink-0" data-id="element-158" />{' '}
                <span className="text-gray-700" data-id="element-159">
                  Bono 1: Audio-Guía SOS 3 AM
                </span>
              </li>
              <li className="flex items-start" data-id="element-160">
                <Check className="w-5 h-5 text-salvia mr-3 flex-shrink-0" data-id="element-161" />{' '}
                <span className="text-gray-700" data-id="element-162">
                  Bono 2: Alimentación y Sueño
                </span>
              </li>
              <li className="flex items-start" data-id="element-163">
                <Check className="w-5 h-5 text-salvia mr-3 flex-shrink-0" data-id="element-164" />{' '}
                <span className="text-gray-700" data-id="element-165">
                  Bono 3: Pack Plantillas Rutinas
                </span>
              </li>
              <li className="flex items-start bg-gold-soft p-3 rounded-lg mt-4" data-id="element-166">
                <BookOpen className="w-5 h-5 text-gold mr-3 flex-shrink-0 mt-1" data-id="element-167" />
                <div className="text-gray-800" data-id="element-168">
                  <span className="font-bold" data-id="element-169">
                    El Diario de la Madrugada (Bitácora de 21 días)
                  </span>
                  <p className="text-sm mt-1 text-gray-600 italic" data-id="element-170">
                    El complemento que convierte el manual en un plan de acción
                    día a día: registrás, ajustás y ves tu progreso paso a paso.
                  </p>
                  <ul className="text-sm mt-2 space-y-1 text-gray-600" data-id="element-171">
                    <li data-id="element-172">→ 21 Fichas de Registro Diario</li>
                    <li data-id="element-173">→ 3 Auditorías Semanales</li>
                    <li data-id="element-174">→ Gráfico de Progreso</li>
                    <li data-id="element-175">→ Momentos Mamá</li>
                  </ul>
                </div>
              </li>
            </ul>

            <div className="text-center mt-auto" data-id="element-176">
              <p className="text-gray-400 line-through mb-2" data-id="element-177">
                Valor total: $47.500 ARS
              </p>
              <p className="text-sm font-bold text-gray-600 mb-1" data-id="element-178">HOY SOLO:</p>
              <p className="text-4xl font-bold text-salvia mb-2" data-id="element-179">$18.900 ARS</p>
              <p className="text-xs text-gray-500 mb-6" data-id="element-180">
                Solo $3.900 más que la Oferta 1 y te llevás la Bitácora que
                sostiene el método por 21 días.
              </p>
              <a href="https://www.mamasincaos.store/cart/45253875597335:1" className="block w-full bg-salvia hover:bg-salvia-dark text-white font-bold py-4 px-6 rounded-xl transition-colors duration-300 text-lg shadow-lg text-center" data-id="element-181">
                QUIERO EL PACK COMPLETO
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function GuaranteeSection() {
  return <section className="bg-salvia-soft py-20 px-6" data-id="element-182">
      <div className="max-w-3xl mx-auto text-center" data-id="element-183">
        <ShieldCheck className="w-20 h-20 text-salvia mx-auto mb-8" data-id="element-184" />
        <h2 className="font-playfair text-3xl md:text-4xl text-salvia-dark font-bold mb-8" data-id="element-185">
          GARANTÍA DE 7 DÍAS SIN PREGUNTAS Y SIN VUELTAS
        </h2>

        <div className="space-y-6 text-lg text-gray-700" data-id="element-186">
          <p data-id="element-187">
            Tenés 7 días de garantía para entrar al Manual, leerlo por dentro,
            aplicar las primeras técnicas y llegar a tu propia conclusión sobre
            si este material es para vos.
          </p>
          <p data-id="element-188">
            Si en ese período sentís que no es lo que necesitabas,{' '}
            <span className="font-bold text-salvia" data-id="element-189">
              te devolvemos el 100% de tu dinero
            </span>
            . Sin preguntas. Sin formularios largos. Sin vueltas.
          </p>
          <div className="w-16 h-px bg-salvia mx-auto my-8" data-id="element-190"></div>
          <p className="font-bold text-salvia-dark" data-id="element-191">
            ¿Por qué ofrecemos esta garantía?
          </p>
          <p data-id="element-192">
            Porque confiamos en lo que creamos. Porque sabemos que cuando una
            mamá agotada aplica este método, los resultados hablan solos. Y
            porque creemos que tu confianza vale más que cualquier venta.
          </p>
        </div>

        <div className="mt-12 flex flex-col md:flex-row justify-center items-center gap-6 text-rose font-medium" data-id="element-193">
          <span className="flex items-center" data-id="element-194">
            <MailIcon className="w-5 h-5 mr-2" data-id="element-195" /> soporte.mamasinkos@gmail.com
          </span>
          <span className="hidden md:inline text-gray-300" data-id="element-196">|</span>
          <span className="flex items-center" data-id="element-197">
            <InstagramIcon className="w-5 h-5 mr-2" data-id="element-198" /> @mamasiincaos
          </span>
        </div>
      </div>
    </section>;
}
function ValueSummarySection() {
  return <section className="bg-cream py-20 px-6" data-id="element-199">
      <div className="max-w-3xl mx-auto" data-id="element-200">
        <h2 className="font-playfair text-3xl text-salvia-dark font-bold text-center mb-10" data-id="element-201">
          💰 MIRÁ TODO LO QUE TE LLEVÁS
        </h2>

        <div className="bg-white rounded-2xl p-8 shadow-md border border-gray-100" data-id="element-202">
          <div className="space-y-4 mb-8" data-id="element-203">
            <div className="flex justify-between items-center text-gray-600" data-id="element-204">
              <span className="flex items-center" data-id="element-205">
                <BookOpen className="w-5 h-5 mr-3 text-salvia" data-id="element-206" /> Pack: El
                manual del sueño infantil
              </span>
              <span data-id="element-207">$25.000</span>
            </div>
            <div className="flex justify-between items-center text-gray-600" data-id="element-208">
              <span className="flex items-center" data-id="element-209">
                <Gift className="w-5 h-5 mr-3 text-rose" data-id="element-210" /> Bono 1: SOS 3 AM
              </span>
              <span data-id="element-211">$4.500</span>
            </div>
            <div className="flex justify-between items-center text-gray-600" data-id="element-212">
              <span className="flex items-center" data-id="element-213">
                <Gift className="w-5 h-5 mr-3 text-rose" data-id="element-214" /> Bono 2: Alimentación
              </span>
              <span data-id="element-215">$6.000</span>
            </div>
            <div className="flex justify-between items-center text-gray-600" data-id="element-216">
              <span className="flex items-center" data-id="element-217">
                <Gift className="w-5 h-5 mr-3 text-rose" data-id="element-218" /> Bono 3: Plantillas
              </span>
              <span data-id="element-219">$3.500</span>
            </div>
            <div className="flex justify-between items-center text-gray-600" data-id="element-220">
              <span className="flex items-center" data-id="element-221">
                <BookOpen className="w-5 h-5 mr-3 text-gold" data-id="element-222" /> Bitácora 21 Días
                (solo en Oferta 2)
              </span>
              <span data-id="element-223">$8.500</span>
            </div>
          </div>

          <div className="border-t border-gray-200 pt-6 mb-6" data-id="element-224">
            <div className="flex justify-between items-center mb-4" data-id="element-225">
              <span className="font-bold text-gray-500" data-id="element-226">VALOR TOTAL:</span>
              <span className="text-red-400 line-through text-xl" data-id="element-227">
                $47.500 ARS
              </span>
            </div>
            <div className="flex justify-between items-center mb-2" data-id="element-228">
              <span className="font-bold text-gray-800" data-id="element-229">OFERTA 1:</span>
              <span className="font-bold text-salvia text-2xl" data-id="element-230">
                $15.000 ARS
              </span>
            </div>
            <div className="flex justify-between items-center" data-id="element-231">
              <span className="font-bold text-gray-800" data-id="element-232">OFERTA 2:</span>
              <span className="font-bold text-salvia text-2xl" data-id="element-233">
                $18.900 ARS
              </span>
            </div>
          </div>

          <div className="bg-gold-soft p-4 rounded-lg flex items-start mb-8" data-id="element-234">
            <span className="text-xl mr-3" data-id="element-235">⚠️</span>
            <p className="text-sm text-gray-800" data-id="element-236">
              <span className="font-bold" data-id="element-237">SOLO DISPONIBLE EN ESTA PÁGINA.</span>{' '}
              Si salís, esta oferta no estará disponible al mismo precio.
            </p>
          </div>

          <a href="https://www.mamasincaos.store/cart/45253875597335:1" className="w-full bg-rose hover:bg-rose-600 text-white font-bold py-5 px-6 rounded-xl transition-colors duration-300 text-lg shadow-lg flex justify-center items-center" data-id="element-238">
            ✨ SÍ, QUIERO MIS NOCHES DE VUELTA ✨
          </a>
        </div>
      </div>
    </section>;
}
function FAQSection() {
  const faqs = [{
    q: '¿Es un método de llanto controlado o de dejar llorar?',
    a: 'No, para nada. El Manual está pensado desde el amor, el respeto y la presencia constante. Vas a enseñarle a tu bebé a dormir de forma gradual, sin abandonarlo a su llanto en ningún momento.'
  }, {
    q: '¿Funciona con bebés que toman teta?',
    a: 'Sí. El método respeta la lactancia y te muestra cómo distinguir el hambre real del hábito, y cómo ir soltando de a poco la asociación teta-sueño sin destetar ni forzar nada.'
  }, {
    q: '¿Desde qué edad puedo aplicarlo?',
    a: 'El manual cubre desde recién nacidos hasta bebés de 12 meses, con tablas y protocolos específicos para cada etapa. Incluso podés empezar durante el embarazo para llegar preparada.'
  }, {
    q: '¿Cuánto tiempo tarda en verse resultados?',
    a: 'La mayoría de las mamás reportan cambios notables entre el día 5 y el día 14 de aplicación consistente del método.'
  }, {
    q: '¿Por cuánto tiempo voy a tener acceso al manual?',
    a: 'Acceso de por vida al eBook y a todos los bonos descargables. Una vez que lo descargás, es tuyo para siempre.'
  }, {
    q: '¿Cómo recibo el acceso?',
    a: 'Inmediatamente después de tu compra recibís un mail con el link de descarga directa de todos los archivos PDF. Sin esperas. Sin contraseñas.'
  }, {
    q: '¿La plataforma de pago es segura?',
    a: 'Sí. Procesamos los pagos a través de plataformas certificadas con encriptación SSL. Tus datos están 100% protegidos.'
  }, {
    q: '¿Tengo dudas antes de comprar, con quién hablo?',
    a: 'Escribinos por Instagram @mamasiincaos o al mail soporte.mamasinkos@gmail.com. Te respondemos en menos de 24 horas.'
  }];
  return <section className="bg-offwhite py-20 px-6" data-id="element-239">
      <div className="max-w-3xl mx-auto" data-id="element-240">
        <h2 className="font-playfair text-3xl md:text-4xl text-salvia-dark font-bold text-center mb-12" data-id="element-241">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-242">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} data-id="element-243" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-xl overflow-hidden bg-white shadow-sm" data-id="element-244">
      <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-245">
        <span className="font-bold text-salvia" data-id="element-246">{question}</span>
        {isOpen ? <Minus className="w-5 h-5 text-rose flex-shrink-0" data-id="element-247" /> : <Plus className="w-5 h-5 text-rose flex-shrink-0" data-id="element-248" />}
      </button>
      <AnimatePresence data-id="element-249">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="overflow-hidden bg-cream" data-id="element-250">
            <div className="px-6 py-5 text-gray-700 border-t border-gray-100" data-id="element-251">
              → {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
function FinalCTASection() {
  return <section className="bg-salvia-dark text-white py-24 px-6 relative overflow-hidden flex flex-col items-center text-center" data-id="element-252">
      <div className="max-w-3xl mx-auto z-10" data-id="element-253">
        <Moon className="w-12 h-12 text-rose mx-auto mb-8" data-id="element-254" />

        <h2 className="font-playfair text-4xl md:text-[48px] leading-tight mb-8" data-id="element-255">
          ¿Hace cuánto que no dormís más de 3 horas seguidas?
        </h2>

        <div className="text-rose text-lg md:text-xl space-y-6 mb-12" data-id="element-256">
          <p data-id="element-257">
            Tu bebé puede aprender a dormir. No porque lo abandones a su llanto.
            Sino porque vos le vas a enseñar, con amor, con método y con
            paciencia.
          </p>
          <p data-id="element-258">Y nosotras vamos a acompañarte en cada paso del proceso.</p>
        </div>

        <p className="font-playfair italic text-2xl mb-12" data-id="element-259">
          Las noches tranquilas que merecés están a un clic de distancia.
        </p>

        <a href="https://www.mamasincaos.store/cart/45253875597335:1" className="inline-block w-full md:w-auto bg-rose hover:bg-rose-600 text-white font-bold py-5 px-10 rounded-xl transition-colors duration-300 text-xl shadow-lg mb-16 text-center" data-id="element-260">
          ✨ QUIERO MIS NOCHES DE VUELTA ✨
        </a>

        <div className="flex flex-col items-center space-y-6 border-t border-salvia pt-12" data-id="element-261">
          <span className="font-playfair text-2xl font-bold tracking-wider text-white" data-id="element-262">
            Mamá sin Caos
          </span>
          <div className="flex flex-col md:flex-row gap-4 md:gap-8 text-sm text-salvia-light" data-id="element-263">
            <span className="flex items-center justify-center" data-id="element-264">
              <InstagramIcon className="w-4 h-4 mr-2" data-id="element-265" /> @mamasiincaos
            </span>
            <span className="flex items-center justify-center" data-id="element-266">
              <MailIcon className="w-4 h-4 mr-2" data-id="element-267" /> soporte.mamasinkos@gmail.com
            </span>
            <span className="flex items-center justify-center" data-id="element-268">
              <GlobeIcon className="w-4 h-4 mr-2" data-id="element-269" /> mamasincaos.store
            </span>
          </div>
          <p className="text-xs text-salvia-light mt-8" data-id="element-270">
            © 2024 Mamá sin Caos Todos los derechos reservados.
          </p>
        </div>
      </div>
    </section>;
}
// Simple Icon wrappers for lucide-react missing ones or specific uses
function MailIcon(props: any) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-271">
      <rect width="20" height="16" x="2" y="4" rx="2" data-id="element-272" />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" data-id="element-273" />
    </svg>;
}
function InstagramIcon(props: any) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-274">
      <rect width="20" height="20" x="2" y="2" rx="5" ry="5" data-id="element-275" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" data-id="element-276" />
      <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" data-id="element-277" />
    </svg>;
}
function GlobeIcon(props: any) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-278">
      <circle cx="12" cy="12" r="10" data-id="element-279" />
      <line x1="2" x2="22" y1="12" y2="12" data-id="element-280" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" data-id="element-281" />
    </svg>;
}